import useResident from './hooks/useResident'
import {
  Spinner,
} from 'react-bootstrap'

const NeedsResident = ({ children }) => {
  const {
    residentLoaded,
  } = useResident()

  if (!residentLoaded) {
    return (
      <Spinner animation="border" role="status" variant="dark">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    )
  }

  return children
}

export default NeedsResident
